import React, { Component } from 'react';

class MandatoryAlert extends Component {
    render() {
        return (
            <div className="text-xs text-darkred mt-1">
                {this.props.text}
            </div>
        );
    }
}

export default MandatoryAlert;